'use no memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import ImportCsv from '@/features/import-csv';
import type { ExportApiUrl } from '@/features/import-csv/types';
import { ImportCsvSearchSchema } from '@/features/import-csv/zod-schemas';
import useIssueTableRows from './-hooks/useIssueTableRows';

/**
 * Issue 一覧 CSV 一括取り込み画面 (/issues/import-csv)。
 *
 * 拠点 (Place) の `/places/import-csv` を踏襲した薄いラッパー。
 * 共通 `ImportCsv` feature に Issue 用の export URL / hook を渡すだけ。
 *
 * テキスト類は MVP 段階のためハードコード。i18n キー化は別タスクで対応する。
 */
const IssueImportCsv = () => {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const exportApiUrl: ExportApiUrl = '/v2/qa-force/issues/csv';
  return <ImportCsv baseLink="/issues/import-csv" baseTitle="不具合をCSVで追加" exportApiUrl={exportApiUrl} exportFilename="issue-list" templateMessage={{
    templateTitle: 'テンプレートをダウンロード',
    updateExisting: '既存データを編集',
    completeLinkButton: '不具合一覧に戻る'
  }} completeLinkUrl="/issues" unit="件" search={search} navigate={navigate} useTableRows={useIssueTableRows} />;
};
export const Route = createFileRoute('/_stacktrace/issues/import-csv')({
  validateSearch: zodValidator(ImportCsvSearchSchema),
  component: IssueImportCsv
});